import { render, staticRenderFns } from "./AccountVerificationDataTable.vue?vue&type=template&id=211d7ab9"
import script from "./AccountVerificationDataTable.vue?vue&type=script&lang=js"
export * from "./AccountVerificationDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports